import {LHeader, LinkText, SGBody} from "../common";
import Grid from "@mui/material/Grid";
import styled from "styled-components";
import {useSelector} from "react-redux";
import {selectBreadcrumbs} from "../../../store/slices/sensorDataSlice";


const SGHeader = styled.div`
    font-family: Space Grotesk;
    font-weight: 500;
`;

export const ClickedSensorExplain = ({ pop }) => {
  const breadcrumbs = useSelector(selectBreadcrumbs);
  return(
    <Grid size={11}>
      <LHeader>
        <LinkText onClick={() => pop('root')}>...</LinkText>{breadcrumbs?.includes('Details') ? <> / <LinkText onClick={() => pop('Details')}>Details</LinkText></> : <></>} / Explain
      </LHeader>

      <Grid container spacing={2} marginTop={'1.5rem'}>
        <Grid size={12}>
          <SGHeader>EPA’s Air Quality Index (AQI)</SGHeader>
          <SGBody>The Air Quality Index (AQI) is a color-coded, 0–500 scale used to communicate how polluted the air is and the associated level of health concern. Higher AQI values indicate higher pollution levels and greater health concerns. An AQI under 100 is generally safe, while values over 100 indicate unhealthy air, particularly for sensitive groups.</SGBody>
        </Grid>
        <Grid size={12}>
          <SGHeader>PM2.5 – Fine Particulate Matter</SGHeader>
          <SGBody>PM2.5 refers to fine particulate matter—tiny solid particles and liquid droplets in the air that have a diameter of 2.5 micrometers in aerodynamic size or smaller. To put their size in perspective, a single human hair is about 70 micrometers wide, making the largest PM2.5 particle 30 times smaller than the width of a hair. PM2.5 is emitted into air from many sources, such as construction sites, unpaved roads, fields, smokestacks or fires, or any combustion source. As “criteria” air pollutant, it is regulated due to its well-established respiratory and cardiovascular health effects. People with heart or lung diseases, children, older adults, minority and low socioeconomic status populations are considered at higher risk because they are more sensitive or may have higher exposures.</SGBody>
        </Grid>
        <Grid size={12}>
          <SGHeader>NO₂ - Nitrogen Dioxide</SGHeader>
          <SGBody>Nitrogen dioxide (NO₂) is a highly reactive, reddish-brown, pungent gas that acts as a primary indicator of traffic-related air pollution and a key component of smog, largely emitted from burning fuels in vehicles, power plants, and industrial facilities. As a "criteria" air pollutant, it is tightly regulated due to its role in causing respiratory illness, particularly asthma, and contributing to the formation of particulate matter PM2.5 and ground-level ozone.</SGBody>
        </Grid>
        {/*<Grid size={12}>
          <SGHeader>BC - Black Carbon</SGHeader>
          <SGBody>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</SGBody>
        </Grid>*/}
      </Grid>
    </Grid>
  );
};
